import script from "./LogXmlReceive.vue?vue&type=script&lang=ts&setup=true"
export * from "./LogXmlReceive.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__